import React, { useState } from 'react';
import { Box, Typography, Modal, Card, CardContent, List, ListItem, ListItemText, useTheme, useMediaQuery, Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import PostProject from './project';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OrganizationsHeader from '../dashboardnavebar';
import DownloadProjects from "../DownloadProject";

const OrganizationsProject = () => {
 const theme = useTheme();
 const isTabletOrBelow = useMediaQuery(theme.breakpoints.down('md'));
 const [open, setOpen] = useState(false);
 const brochureName = "projectSubmissionTemplate.pdf";
 const handleOpen = () => setOpen(true);
 const handleClose = () => setOpen(false);

  return (
    <div className="students-flex">
      <OrganizationsHeader />
       <Box 
            sx={{
              background: 'linear-gradient(to right, #e0f7fa, #f1f8e9)',
              blockSize: isTabletOrBelow ? 'auto' : '91vh',
              overflowY: isTabletOrBelow ? 'visible' : 'auto',
              padding: isTabletOrBelow ? '10px' : '20px',
            }}>
            {/* Top-right Button */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpen}
                sx={{ textTransform: 'none' }}
              >
                Download Project Submission Template
              </Button>
            </Box>
      
            {/* Main Content */}
            <Box
              sx={{
                background: 'linear-gradient(to right, #e0f7fa, #f1f8e9)',
                display: 'flex',
                flexDirection: isTabletOrBelow ? 'column' : 'row',
                justifyContent: 'center',
                alignItems: 'flex-start',
                overflowY: isTabletOrBelow ? 'visible' : 'auto',
                padding: isTabletOrBelow ? '10px' : '40px',
                gap: 4,
              }}
            >
          <Box>
          <PostProject />
        </Box>
      </Box>
      {/* Popup Modal */}
      <Modal open={open} onClose={handleClose} scroll="body">
     <Box
        sx={{
          position: 'absolute',
          top : '50%',
          left : '50%',
          transform: 'translate(-50%, -50%)',
          width : '90%',
          maxWidth : 600,
          maxHeight : '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          outline: 'none',
          overflowY: 'auto',
        }}
        >
        {/* Close Icon */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top : 8,
            right : 8,
            color: 'grey.600',
          }}
        >
          <CloseIcon />
        </IconButton>
      <Typography variant="h6" fontWeight="bold" gutterBottom color="#043885">
       Empowering innovation through industry collaboration.
      </Typography>
      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          <List dense>
            <ListItem>
              <ListItemText primary="This template helps organizations structure and organize project details before submitting to the Huebits platform. It streamlines the process, clarifies expectations, and enables smooth execution with minimal back-and-forth." />
            </ListItem>
          </List>
        </CardContent>
      </Card>

      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Project Submission Form Guidelines:
      </Typography>

      <Typography variant="body2" sx={{ mb: 2 }}>
        <ArrowForward fontSize="small" sx={{ mr: 1 }} />
        <DownloadProjects brochureName={brochureName} /> and fill in all the required fields.
      </Typography>

      <Typography variant="body2">
        All fields in the form are mandatory. This ensures clear and complete communication between your organization and our team. The format is tailored for project submissions, allowing you to provide essential details quickly while maintaining consistency and clarity.
      </Typography>
      </Box>
      </Modal>
      </Box>
    </div>
  );
};

export default OrganizationsProject;
